import type { RunState } from "../domain/types/index.js";
import { HinduShuffleMotion } from "./hinduShuffle/HinduShuffleMotion.js";
import { ZoneIcon } from "./ZoneIcon.js";

export function DeckStatus({ run, discardGain }: { run: RunState; discardGain?: number }) {
  const lastLog = run.log.at(-1);
  const reshuffled = lastLog?.kind === "deck";

  return (
    <div className={`deck-status${reshuffled ? " is-reshuffling" : ""}`} aria-label={`手札 ${run.hand.length} 枚、山札 ${run.deck.length} 枚、捨て札 ${run.discard.length} 枚`}>
      <span className="deck-zone" data-deck-zone="hand" title="手札"><ZoneIcon name="hand" /><small>手札</small><b>{run.hand.length}</b></span>
      <span className="deck-zone" data-deck-zone="deck" title="山札"><ZoneIcon name="deck" /><small>山札</small><b>{run.deck.length}</b></span>
      <span className="deck-zone" data-deck-zone="discard" title="捨て札">
        <ZoneIcon name="discard" /><small>捨て札</small><b className={discardGain ? "is-value-change is-positive" : ""}>{run.discard.length}{discardGain ? <span className="change-delta">+{discardGain}</span> : null}</b>
        {reshuffled && <HinduShuffleMotion key={run.log.length} />}
      </span>
      {reshuffled && <p className="deck-reshuffle" role="status">山札を再構成しました</p>}
    </div>
  );
}
